import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_PERSONA } from "./dbConstants";

export const getListOptions = async(input) => {
  console.log("PersonaDAO.getListOptions - input:", input);
  const companyId = input?.companyId || null;
  return getLookupList(ENTITY_NAME_PERSONA, { companyId })
}